var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { BooleanInput, SimpleForm, TextInput, SelectInput, ReferenceInput, Create, FormDataConsumer, NumberInput, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
export var CreateDocument = function () {
    return (_jsx(Create, { children: _jsxs(SimpleForm, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: "Document" })), _jsx(Typography, __assign({ variant: "body2" }, { children: "Document creation" })), _jsx(TextInput, { source: "name" }), _jsx(TextInput, { source: "media_type" }), _jsx(NumberInput, { source: "size" }), _jsx(BooleanInput, { source: "is_public" }), _jsx(ReferenceInput, __assign({ source: "tenant_id", reference: "sequent_backend_tenant" }, { children: _jsx(SelectInput, { optionText: "username" }) })), _jsx(FormDataConsumer, { children: function (_a) {
                        var formData = _a.formData;
                        return (_jsx(_Fragment, { children: _jsx(ReferenceInput, __assign({ source: "election_event_id", reference: "sequent_backend_election_event", filter: { tenant_id: formData.tenant_id } }, { children: _jsx(SelectInput, { optionText: "name" }) })) }));
                    } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } })] }) }));
};
